import { IAccount, IAccountPermission } from '../interface/auth';
import { getAppRole } from './role';

export const canViewModule = (
  user: IAccount | undefined,
  permission: IAccountPermission | undefined,
  module?: string
) => {
  const role = getAppRole(user);
  if (!module) return role === 'seniorAdmin' || role === 'otherAdmin';
  if (role === 'seniorAdmin') return true;
  if (role !== 'otherAdmin') return false;

  // modules with a `view` action use it; others (Senior Medical: manageMedication, manageAllergy...)
  // are reachable when any of their actions is granted
  const actions = permission?.[module];
  if (!actions) return false;
  return 'view' in actions ? actions.view === true : Object.values(actions).some((granted) => granted === true);
};

export const canUpdateModule = (
  user: IAccount | undefined,
  permission: IAccountPermission | undefined,
  module: string
) => {
  const role = getAppRole(user);
  if (role === 'seniorAdmin') return true;
  if (role === 'otherAdmin') return permission?.[module]?.update === true;
  return false;
};

// `action` is the camelCase permission action key (view/create/update/delete).
export const canDoAction = (
  user: IAccount | undefined,
  permission: IAccountPermission | undefined,
  module: string,
  action: string
) => {
  const role = getAppRole(user);
  if (role === 'seniorAdmin') return true;
  if (role === 'otherAdmin') return permission?.[module]?.[action] === true;
  return false;
};
